<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="props.width"
    :height="props.height"
    viewBox="0 0 800 344"
  >
    <g
      transform="translate(0.000000,344.000000) scale(0.100000,-0.100000)"
      :fill="props.fill"
      stroke="none"
    >
      <path
        d="M1527 3409 c-275 -32 -572 -146 -798 -306 -121 -86 -315 -281 -401
-403 -129 -182 -228 -414 -280 -650 -20 -92 -22 -133 -22 -335 0 -258 11 -338
80 -543 272 -811 1112 -1294 1954 -1122 219 45 458 148 640 277 122 87 317
282 402 403 553 785 355 1867 -441 2401 -331 223 -743 324 -1134 278z m502
-139 c309 -65 584 -215 805 -436 227 -226 373 -503 438 -826 29 -149 31 -413
4 -563 -39 -213 -134 -445 -259 -629 -81 -120 -283 -322 -403 -403 -415 -281
-926 -355 -1389 -202 -909 302 -1346 1326 -934 2189 71 149 167 287 282 407
254 264 551 419 912 478 134 21 408 14 544 -15z"
      />
      <path
        d="M464 2436 c-105 -64 -103 -221 3 -283 55 -32 132 -30 183 7 36 26 70
90 70 135 0 45 -34 109 -71 135 -50 36 -132 39 -185 6z"
      />
      <path
        d="M1215 2270 c-163 -33 -312 -143 -387 -287 -66 -125 -68 -140 -68
-632 l0 -441 114 0 c150 0 146 -5 146 183 0 76 3 137 8 135 111 -56 194 -78
292 -78 163 0 284 51 401 169 157 157 207 374 135 582 -90 260 -373 422 -641
369z m228 -278 c184 -81 235 -339 96 -482 -149 -153 -394 -117 -488 72 -55
109 -38 239 43 335 80 95 231 127 349 75z"
      />
      <path
        d="M2356 2265 c-158 -40 -307 -159 -374 -297 -186 -383 84 -817 508
-818 86 0 171 19 242 55 60 30 58 30 58 5 0 -11 9 -29 20 -40 18 -18 33 -20
130 -20 l110 0 0 318 c0 357 -6 398 -67 514 -92 176 -268 285 -473 294 -63 2
-115 -1 -154 -11z m268 -279 c65 -32 110 -80 144 -154 49 -109 14 -268 -77
-343 -84 -69 -182 -92 -277 -64 -147 43 -232 164 -222 314 16 214 239 341 432
247z"
      />
      <path
        d="M436 2064 c-14 -14 -16 -68 -16 -448 0 -323 3 -435 12 -444 16 -16
220 -16 236 0 9 9 12 121 12 444 l0 433 -22 15 c-32 23 -200 23 -222 0z"
      />
      <path
        d="M4590 2714 l0 -96 -30 26 c-40 33 -105 43 -156 21 -84 -35 -120 -102
-111 -210 8 -112 72 -177 172 -177 42 0 105 27 105 44 0 4 5 8 10 8 6 0 10
-11 10 -25 0 -24 3 -25 55 -25 l55 0 0 265 0 265 -55 0 -55 0 0 -96z m-26
-165 c25 -28 28 -38 24 -81 -8 -82 -68 -123 -134 -92 -37 18 -54 50 -54 105 0
50 12 74 48 94 38 21 82 11 116 -26z"
      />
      <path
        d="M6750 2722 l0 -89 -50 25 c-71 35 -129 25 -186 -31 -114 -115 -56
-335 91 -348 59 -4 84 1 114 27 l31 26 0 -26 c0 -25 2 -26 55 -26 l55 0 0 265
0 265 -55 0 -55 0 0 -88z m-43 -152 c72 -44 61 -171 -19 -199 -41 -15 -92 7
-113 50 -30 58 -6 137 50 160 31 12 48 10 82 -11z"
      />
      <path d="M3698 2535 l3 -255 49 0 50 0 0 255 0 255 -52 0 -53 0 3 -255z" />
      <path
        d="M7780 2720 c0 -45 -2 -50 -22 -50 -20 0 -23 -5 -23 -45 0 -39 3 -45
22 -45 21 0 21 -4 25 -126 3 -124 3 -126 31 -150 21 -18 40 -24 75 -24 82 0
92 7 92 55 l0 42 -42 -1 -43 -1 -3 103 -3 102 46 0 45 0 0 45 0 45 -45 0 -45
0 0 50 0 50 -55 0 -55 0 0 -50z"
      />
      <path
        d="M4055 2664 c-16 -8 -38 -23 -47 -31 -17 -15 -18 -14 -18 10 0 26 -3
27 -50 27 l-50 0 0 -195 0 -195 49 0 49 0 4 129 c3 146 14 171 73 171 56 0 64
-20 67 -165 l3 -130 53 -3 52 -3 0 153 c0 136 -2 157 -20 186 -34 56 -108 76
-165 46z"
      />
      <path
        d="M4876 2665 c-47 -17 -94 -59 -112 -102 -18 -41 -18 -134 0 -176 45
-110 216 -149 311 -72 l30 23 -29 30 -28 30 -32 -19 c-48 -29 -101 -25 -137
10 -16 16 -29 34 -29 40 0 7 47 11 141 11 l141 0 -7 53 c-13 93 -51 147 -122
173 -48 17 -78 17 -127 -1z m119 -100 c14 -13 25 -33 25 -45 0 -20 -5 -21 -82
-18 -49 2 -83 7 -85 14 -2 6 8 26 22 43 34 40 84 43 120 6z"
      />
      <path
        d="M5360 2669 c-14 -6 -35 -20 -47 -31 l-23 -21 0 26 c0 26 -2 27 -55
27 l-55 0 0 -256 0 -255 53 3 52 3 3 83 3 83 30 -25 c30 -26 55 -31 114 -27
104 9 171 125 144 250 -23 108 -129 176 -219 140z m88 -113 c52 -52 34 -154
-33 -182 -67 -28 -128 21 -128 102 0 99 95 147 161 80z"
      />
      <path
        d="M5747 2665 c-107 -38 -158 -171 -108 -281 53 -117 239 -150 324 -56
17 19 16 20 -16 44 -32 25 -33 25 -56 7 -35 -29 -105 -26 -136 6 -50 49 -39
55 110 55 l135 0 0 33 c0 89 -59 176 -135 196 -51 14 -71 13 -118 -4z m122
-101 c12 -15 21 -35 21 -45 0 -17 -9 -19 -78 -19 -43 0 -82 3 -85 6 -7 8 8 41
31 67 24 28 86 23 111 -9z"
      />
      <path
        d="M6230 2669 c-14 -6 -35 -20 -47 -31 l-23 -21 0 26 c0 26 -2 27 -55
27 l-55 0 0 -195 0 -195 55 0 55 0 0 130 c0 117 2 132 20 150 20 20 65 26 86
12 26 -17 34 -56 34 -171 l0 -121 56 0 56 0 -4 153 c-4 161 -12 194 -54 222
-30 20 -93 27 -124 14z"
      />
      <path
        d="M7035 2666 c-94 -35 -148 -156 -113 -257 29 -88 95 -132 193 -132 63
0 106 16 138 51 17 19 17 20 -9 41 -31 25 -42 26 -68 6 -33 -25 -99 -19 -130
11 -49 49 -40 54 109 54 l135 0 0 43 c0 58 -42 140 -85 167 -44 27 -119 34
-170 16z m122 -98 c12 -13 23 -32 25 -43 3 -18 -3 -20 -79 -23 -78 -3 -83 -2
-83 18 0 60 96 93 137 48z"
      />
      <path
        d="M7520 2669 c-14 -5 -35 -20 -47 -31 l-23 -21 0 26 c0 26 -2 27 -55
27 l-55 0 0 -195 0 -195 55 0 55 0 0 124 c0 110 2 126 21 150 25 32 70 35 99
6 18 -18 20 -33 20 -150 l0 -130 55 0 55 0 -1 143 c0 156 -10 200 -50 229 -31
23 -95 32 -129 17z"
      />
      <path
        d="M4140 1745 l0 -265 55 0 55 0 0 129 c0 104 3 133 16 145 37 38 96 27
114 -20 6 -14 10 -77 10 -140 l0 -114 53 0 52 0 -5 166 -5 166 -33 29 c-27 24
-41 29 -86 29 -44 0 -60 -5 -85 -26 l-31 -26 0 96 0 96 -55 0 -55 0 0 -265z"
      />
      <path d="M6710 1963 l0 -48 55 0 55 0 0 48 0 47 -55 0 -55 0 0 -47z" />
      <path
        d="M3690 1735 l0 -255 55 0 55 0 0 74 0 73 78 6 c92 6 149 31 184 79 32
45 33 153 2 194 -51 68 -97 83 -261 84 l-113 0 0 -255z m265 130 c33 -32 33
-78 0 -110 -21 -22 -33 -25 -90 -25 l-65 0 0 80 0 80 65 0 c57 0 69 -3 90 -25z"
      />
      <path
        d="M4618 1858 c-41 -11 -44 -18 -27 -66 10 -28 12 -30 42 -21 80 23 147
4 161 -47 6 -20 4 -21 -72 -16 -99 6 -147 -13 -169 -67 -28 -66 -2 -129 64
-157 45 -19 82 -17 128 6 47 24 59 25 51 5 -4 -12 5 -15 50 -15 l56 0 -4 143
c-3 161 -16 198 -78 229 -39 20 -139 23 -202 6z m160 -214 c47 -13 6 -87 -55
-99 -26 -5 -37 -2 -58 19 -54 55 17 105 113 80z"
      />
      <path
        d="M4970 1675 l0 -195 54 0 54 0 4 111 3 111 33 29 c18 16 43 29 57 29
24 0 25 3 25 55 0 53 -1 55 -26 55 -16 0 -39 -13 -60 -34 l-34 -34 0 34 0 34
-55 0 -55 0 0 -195z"
      />
      <path
        d="M5250 1675 l0 -195 49 0 49 0 4 131 c3 123 4 132 27 150 31 26 57 24
86 -6 24 -23 25 -30 25 -150 l0 -125 55 0 55 0 0 130 c0 117 2 132 20 150 11
11 31 20 45 20 14 0 34 -9 45 -20 18 -18 20 -33 20 -150 l0 -130 55 0 55 0 0
145 c0 207 -20 245 -130 245 -44 0 -64 -6 -95 -27 -25 -17 -40 -22 -43 -14 -7
20 -60 41 -106 41 -33 0 -52 -6 -74 -25 -17 -14 -33 -25 -36 -25 -3 0 -6 11
-6 25 0 23 -3 25 -50 25 l-50 0 0 -195z"
      />
      <path
        d="M5968 1858 c-41 -11 -44 -18 -27 -66 10 -28 12 -30 42 -21 80 23 157
1 157 -44 0 -22 -3 -22 -69 -19 -39 2 -85 -1 -106 -8 -44 -15 -75 -60 -75
-112 0 -98 140 -153 224 -87 l26 20 0 -20 c0 -19 6 -21 56 -21 l56 0 -3 143
c-5 161 -16 195 -79 228 -39 21 -137 24 -202 7z m166 -221 c13 -10 15 -18 8
-38 -14 -37 -37 -51 -83 -53 -63 -1 -89 44 -49 84 23 23 96 28 124 7z"
      />
      <path
        d="M6415 1856 c-99 -44 -144 -179 -92 -277 58 -109 214 -143 309 -66
l27 22 -29 32 -28 32 -38 -20 c-46 -23 -66 -24 -104 -4 -33 17 -47 38 -50 75
-4 50 1 69 26 99 21 25 33 31 66 31 23 0 51 -8 67 -19 l27 -20 28 35 c24 30
26 37 14 51 -34 41 -159 57 -223 29z"
      />
      <path d="M6710 1675 l0 -195 55 0 55 0 0 195 0 195 -55 0 -55 0 0 -195z" />
      <path
        d="M6995 1858 c-71 -39 -108 -101 -109 -183 -1 -76 25 -129 83 -170 38
-27 51 -30 115 -30 62 0 78 4 114 28 23 15 42 31 42 36 0 6 -13 19 -30 31 -26
19 -32 19 -52 6 -45 -29 -112 -24 -143 10 -46 50 -38 54 110 54 l135 0 0 40
c0 72 -42 145 -102 176 -32 17 -134 18 -163 2z m136 -97 c50 -51 41 -61 -56
-61 -71 0 -85 3 -85 16 0 25 56 74 85 74 16 0 38 -12 56 -29z"
      />
      <path
        d="M7372 1853 c-44 -21 -66 -65 -59 -117 7 -52 36 -77 122 -106 72 -24
90 -44 59 -67 -23 -17 -71 -10 -124 17 l-36 18 -21 -33 c-24 -36 -22 -40 33
-68 52 -27 128 -32 179 -12 53 20 75 54 75 115 0 54 -26 79 -118 114 -62 24
-73 31 -70 50 4 27 52 33 103 12 43 -18 48 -17 65 25 11 26 11 32 -1 40 -49
31 -156 38 -207 12z"
      />
      <path d="M6048 985 l-3 -265 53 0 52 0 0 265 0 265 -50 0 -49 0 -3 -265z" />
      <path d="M6250 1200 l0 -50 55 0 55 0 0 50 0 50 -55 0 -55 0 0 -50z" />
      <path
        d="M3761 988 c-57 -134 -106 -249 -108 -255 -4 -10 10 -13 50 -13 l55 0
22 55 22 55 112 0 111 0 21 -53 22 -52 57 -3 c44 -2 56 0 52 10 -2 7 -51 122
-108 256 l-103 242 -51 0 -51 0 -103 -242z m193 19 c14 -37 26 -69 26 -72 0
-3 -29 -5 -65 -5 -36 0 -65 4 -65 9 0 5 7 25 15 45 53 129 48 127 89 23z"
      />
      <path
        d="M5060 1160 c0 -47 -2 -50 -25 -50 -23 0 -25 -4 -25 -44 0 -39 3 -45
23 -48 21 -3 22 -8 27 -130 5 -116 7 -130 28 -150 18 -18 34 -23 75 -23 76 0
87 7 87 55 l0 40 -40 0 c-48 0 -52 10 -48 125 l3 80 45 3 45 3 -1 42 -1 42
-47 3 -46 3 0 50 0 49 -50 0 -50 0 0 -50z"
      />
      <path
        d="M4242 951 c3 -144 5 -162 24 -188 44 -59 134 -67 194 -17 l30 26 0
-26 c0 -25 2 -26 55 -26 l55 0 -2 193 -3 192 -52 3 -53 3 0 -121 c0 -153 -11
-180 -77 -180 -54 0 -63 25 -63 172 l0 128 -56 0 -55 0 3 -159z"
      />
      <path
        d="M4733 1090 c-41 -24 -53 -48 -53 -102 0 -56 32 -89 110 -114 65 -20
80 -30 80 -55 0 -36 -73 -36 -137 1 l-32 19 -22 -35 c-21 -34 -21 -36 -3 -49
24 -18 109 -45 143 -45 84 0 140 43 148 112 7 59 -27 100 -100 123 -65 21 -97
41 -97 60 0 24 50 30 99 12 51 -18 55 -17 76 24 l16 30 -43 19 c-57 26 -143
26 -185 0z"
      />
      <path
        d="M5330 915 l0 -195 50 0 50 0 0 73 c0 39 5 90 10 112 11 47 59 95 95
95 24 0 25 3 25 55 0 54 -1 55 -29 55 -21 0 -38 -10 -60 -35 -17 -19 -33 -35
-36 -35 -3 0 -5 16 -5 35 l0 35 -50 0 -50 0 0 -195z"
      />
      <path
        d="M5675 1096 c-42 -13 -44 -20 -25 -72 8 -20 12 -22 42 -13 77 22 158
-4 158 -50 0 -16 -7 -18 -69 -13 -119 8 -181 -30 -181 -112 0 -55 18 -87 60
-109 45 -24 120 -18 161 12 29 21 29 21 29 1 0 -17 6 -20 50 -20 l50 0 0 141
c0 168 -10 197 -74 229 -48 23 -137 26 -201 6z m159 -212 c27 -10 20 -61 -10
-81 -32 -20 -86 -22 -108 -4 -23 19 -20 57 6 75 23 16 83 21 112 10z"
      />
      <path d="M6250 915 l0 -195 55 0 55 0 0 195 0 195 -55 0 -55 0 0 -195z" />
      <path
        d="M6508 1099 c-41 -12 -44 -19 -27 -68 9 -24 15 -30 28 -25 9 3 40 9
68 12 62 5 103 -15 103 -51 0 -22 -3 -22 -74 -19 -86 5 -138 -14 -161 -59 -33
-62 -7 -138 56 -163 52 -21 87 -20 134 4 47 24 45 24 45 5 0 -12 13 -15 56
-15 l56 0 -4 143 c-4 156 -13 189 -65 222 -33 22 -158 30 -215 14z m163 -219
c25 -14 24 -33 -5 -67 -42 -49 -136 -32 -136 24 0 7 9 22 20 33 22 22 88 27
121 10z"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    width?: string | number
    height?: string | number
    fill?: string
  }>(),
  {
    width: 812,
    height: 272,
    fill: '#ffffff'
  }
)
</script>
